"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _react = require("react");

var React = _interopRequireWildcard(_react);

var _lodash = require("lodash");

var _reactBootstrap = require("react-bootstrap");

var _StatusWrapper = require("../../../components/StatusWrapper");

var _StatusWrapper2 = _interopRequireDefault(_StatusWrapper);

var _reactIntl = require("react-intl");

var _reactCssModules = require("react-css-modules");

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactRedux = require("react-redux");

var _tcombForm = require("tcomb-form");

var _tcombForm2 = _interopRequireDefault(_tcombForm);

var _tcomb = require("tcomb");

var t = _interopRequireWildcard(_tcomb);

var _TCombFormWrapper = require("../../../components/TCombFormWrapper");

var _TCombFormWrapper2 = _interopRequireDefault(_TCombFormWrapper);

var _ReportDetailAddEditTypeModal = require("./ReportDetailAddEditTypeModal");

var _ReportDetailAddEditTypeModal2 = _interopRequireDefault(_ReportDetailAddEditTypeModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var styles = require("./ReportDetailTableFieldTemplate.less");

var Form = _tcombForm2.default.form.Form;

function IntermediateRowWrapper(props) {
    return props.children;
}
var ReportDetailTableFieldTemplate = function (_React$Component) {
    _inherits(ReportDetailTableFieldTemplate, _React$Component);

    function ReportDetailTableFieldTemplate(props) {
        _classCallCheck(this, ReportDetailTableFieldTemplate);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ReportDetailTableFieldTemplate).call(this, props));

        _this.onHide = function () {
            _this.setState({
                showModal: null,
                isLoading: _this.state.isLoading,
                currentFormData: _this.state.currentFormData,
                awaitingTransitionToAddTypeModal: false
            });
        };
        _this.onShow = function (modal) {
            // fix transition from chooseType to addType loses focus
            // simply timeout the transition until chooseType is fully hidden (onExited)...
            // see http://react-bootstrap.github.io/components.html#modals-props
            var awaitingTransitionToAddTypeModal = false;
            var showModal = modal;
            if (_this.state.showModal === "chooseType" && modal === "addType") {
                awaitingTransitionToAddTypeModal = true;
                showModal = null; // overwrite the modal to show, this will be triggered automatically after the transition has existed!
            }
            _this.setState({
                showModal: showModal,
                isLoading: _this.state.isLoading,
                currentFormData: _this.state.currentFormData,
                awaitingTransitionToAddTypeModal: awaitingTransitionToAddTypeModal // this flag explicitly requests this transition!
            });
        };
        _this.onModalExisted = function () {
            if (_this.state.awaitingTransitionToAddTypeModal === true) {
                // now open he other modal and forget the transition operation!
                _this.setState({
                    showModal: "addType",
                    isLoading: _this.state.isLoading,
                    currentFormData: _this.state.currentFormData,
                    awaitingTransitionToAddTypeModal: false // forget.
                });
            }
        };
        _this.addItem = function (refUid) {
            _this.props.addItem(_this.props.dispatch, refUid);
            _this.onHide();
        };
        _this.onFormSubmit = function (e) {
            e.preventDefault();
            var tempRefs = _this.refs;
            var data = tempRefs.form.getValue();
            if (data.instanceUid) {
                _this.addItem(data.instanceUid);
            }
        };
        _this.onFormChange = function (data) {
            var state = _this.state;
            state.currentFormData = data;
            _this.setState(state);
        };
        _this.state = {
            currentFormData: null,
            showModal: null,
            isLoading: false,
            awaitingTransitionToAddTypeModal: false
        };
        return _this;
    }

    _createClass(ReportDetailTableFieldTemplate, [{
        key: "render",
        value: function render() {
            var _this2 = this;

            var formatMessage = this.props.intl.formatMessage;

            var schema = t.struct({
                instanceUid: t.String
            });
            var instancesOfType = (0, _lodash.chain)(this.props.reportDetail.reportData).filter(function (data) {
                return data.dataDefinition.uid === _this2.props.typeDefinitionUid;
            }).map(function (data) {
                return (0, _lodash.chain)(data.dataEntries).value();
            }).flatten().filter(function (data) {
                return !(0, _lodash.includes)(_this2.props.usedUids, data.uid);
            }).map(function (data) {
                return {
                    text: data.title,
                    value: data.uid
                };
            }).value();
            this.props.reportDetail.selectedReport.data.fields.forEach(function (field) {
                if (field.type === "table") {
                    var _data = field.data;
                    _data.rows.forEach(function (row) {
                        for (var i = 0; i < instancesOfType.length; i++) {
                            if (row.ref === instancesOfType[i].value) {
                                instancesOfType = [].concat(_toConsumableArray(instancesOfType.slice(0, i)), _toConsumableArray(instancesOfType.slice(i + 1)));
                            }
                        }
                    });
                }
            });
            var schemaOptions = {
                fields: {
                    instanceUid: {
                        label: formatMessage({ id: "reportStep.table.modal.chooseType" }),
                        factory: _tcombForm2.default.form.Select,
                        options: instancesOfType
                    }
                }
            };
            var nameSingular = null;
            var definition = (0, _lodash.head)((0, _lodash.chain)(this.props.reportDetail.reportData).filter(function (reportData) {
                return reportData.dataDefinition.uid === _this2.props.typeDefinitionUid;
            }).value());
            if (definition) {
                nameSingular = definition.dataDefinition.nameSingular;
            }
            var chooseTypeModal = React.createElement(_reactBootstrap.Modal, { show: this.state.showModal === "chooseType", onHide: this.onHide, enforceFocus: false, onExited: this.onModalExisted }, React.createElement(_StatusWrapper2.default, { isLoading: this.state.isLoading, error: this.state.error, onDismissError: this.state.dismissError }, React.createElement(_reactBootstrap.Modal.Header, { closeButton: true }, React.createElement(_reactBootstrap.Modal.Title, null, nameSingular, " ", React.createElement(_reactIntl.FormattedMessage, { id: "reportStep.table.modal.chooseType" }))), React.createElement(_reactBootstrap.Modal.Body, null, React.createElement(_TCombFormWrapper2.default, { onSubmit: this.onFormSubmit, ref: "form", type: schema, options: schemaOptions, value: this.state.currentFormData, onChange: this.onFormChange }), React.createElement(_reactBootstrap.Button, { bsStyle: "primary", onClick: function onClick() {
                    return _this2.onShow("addType");
                } }, React.createElement("i", { className: "fa fa-plus" }), " ", nameSingular, " ", React.createElement(_reactIntl.FormattedMessage, { id: "reportDetail.type.empty.postfix" }))), React.createElement(_reactBootstrap.Modal.Footer, null, React.createElement(_reactBootstrap.Row, null, React.createElement(_reactBootstrap.Col, { xs: 12 }, React.createElement(_reactBootstrap.ButtonGroup, null, React.createElement(_reactBootstrap.Button, { bsStyle: "primary", onClick: this.onFormSubmit }, React.createElement("i", { className: "fa fa-save" }), " ", React.createElement(_reactIntl.FormattedMessage, { id: "reportList.save.title" }))))))));
            var addTypeModal = React.createElement(_ReportDetailAddEditTypeModal2.default, { mode: "add", saveReportBeforeAddType: true, onClose: this.onHide, onSuccess: this.addItem, showModal: this.state.showModal === "addType", reportDataDefinitionUid: this.props.typeDefinitionUid });
            var refTitle = (0, _lodash.head)((0, _lodash.chain)(this.props.reportDetail.reportData).filter(function (reportData) {
                return reportData.dataDefinition.uid === _this2.props.typeDefinitionUid;
            }).value());
            var minMaxComponent = null;
            var minMaxTitleComponent = null;
            if (this.props.minMaxTitle) {
                minMaxTitleComponent = React.createElement(_reactBootstrap.Row, null, React.createElement(_reactBootstrap.Col, { xs: 12 }, React.createElement("h4", null, this.props.minMaxTitle)));
            }
            if (this.props.max && this.props.min) {
                minMaxComponent = React.createElement(_reactBootstrap.Row, null, React.createElement(_reactBootstrap.Col, { xs: 6 }, React.createElement("span", null, React.createElement(_reactIntl.FormattedMessage, { id: "reportDetail.table.referenceMax" }), " ", this.props.max)), React.createElement(_reactBootstrap.Col, { xs: 6 }, React.createElement("span", { className: "pull-right" }, React.createElement(_reactIntl.FormattedMessage, { id: "reportDetail.table.referenceMin" }), " ", this.props.min)));
            }
            return React.createElement("div", { key: this.props.dataFieldUuid + "template" }, React.createElement("h3", null, this.props.title), React.createElement(_reactBootstrap.Grid, { style: { width: "100%" } }, minMaxTitleComponent, minMaxComponent), React.createElement("table", { styleName: "table-field", key: this.props.dataFieldUuid + "table" }, React.createElement("thead", null, React.createElement("tr", null, React.createElement("th", { colSpan: 4, style: { width: "100%" } }, refTitle.dataDefinition.namePlural))), React.createElement("tbody", null, function () {
                return (0, _lodash.chain)(_this2.props.locals.items).map(function (item, index) {
                    return React.createElement(IntermediateRowWrapper, { key: index }, item.input);
                }).value();
            }())), chooseTypeModal, addTypeModal, React.createElement(_reactBootstrap.ButtonGroup, { style: { paddingBottom: "10px" } }, React.createElement(_reactBootstrap.Button, { bsStyle: "primary", disabled: this.props.locals.disabled, onClick: function onClick() {
                    return _this2.onShow("chooseType");
                } }, React.createElement("i", { className: "fa fa-plus" }), " ", React.createElement(_reactIntl.FormattedMessage, { id: "reportStep.table.addItem" }))));
        }
    }]);

    return ReportDetailTableFieldTemplate;
}(React.Component);
ReportDetailTableFieldTemplate = __decorate([_reactIntl.injectIntl, (0, _reactRedux.connect)(function (state) {
    return {
        reportDetail: state.reportDetail
    };
}), (0, _reactCssModules2.default)(styles)], ReportDetailTableFieldTemplate);
exports.default = ReportDetailTableFieldTemplate;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/containers/reportDetail/ReportDetailTableFieldTemplate.tsx
 ** module id = 632
 ** module chunks = 0
 **/